import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 10;
    }

    .app-logo {
      margin-bottom: 20px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  margin-bottom: 24px;
`;

export const SubtitleStyles = styled(UiTypography)`
  color: var(--text-color-neutral-white);
  margin-top: 12px;
  text-transform: none;
`;

export const MainImageStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const OverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(20, 17, 30, 0) 43.75%,
    rgba(20, 17, 30, 0.8) 69.09%,
    #14111e 84.92%
  );
`;
